<div class="add-appointment" *ngIf="appointment">
    <div class="icon-bar">
        <div class="icon calendar-icon mt-m10px">
            <i class="fal fa-calendar-day"></i>
        </div>
        <div class="icon user-note">
            <i class="fal fa-sticky-note"></i>
        </div>
    </div>
    <div class="ui-g-12 appt-right-content">
        <div class="ui-g-12 p-zero left-box pl-2 pt-0 my-3">
            <div class="block-dialog-height-300">
                <div class="ui-g-12 p-zero">
                    <div class="ui-g-12 p-zero">
                        <div class="appointment-time-row flex-start-center mt-0">
                            <!-- Start Date -->
                            <div>
                                <div class="form-group appointment-form-group appointment-calendar from-calender border-bottom-white calendar-dropdown"
                                    #startDateCalendarContainer>
                                    <p-calendar id="start-date" dateFormat="M dd, yy"
                                         [(ngModel)]="appointment.date.start"
                                        (onFocus)="onFocusInput('calendar')" (onBlur)="onBlurInput('calendar')"
                                        (onSelect)="onSelectStartDate($event)" #startDateCalendar>
                                    </p-calendar>
                                </div>
                            </div>

                            <!-- Start Time -->
                            <div>
                                <div
                                    class="form-group appointment-form-group appointment-time pl-4px border-bottom-white">
                                    <app-dropdown id="start-time" listId="start-time-list" idKey="i" field="label"
                                        scrollHeight="152px" theme="light" styleClassSelectedView="time-dropdown"
                                        itemWidth="150px" styleClassDropdownList="border-none"
                                         [autoFocus]="focus?.startTime"
                                        [hasBorderBottomOnActive]="false" [options]="times"
                                        [setPositionDynamically]="false" [fontSize]="14" [isInline]="true"
                                        [value]="selectedTime.start" [focusOnSelectedValue]="true"
                                        [isDropdownIconVisible]="false" (appSelect)="onSelectStartTime($event)"
                                        (appOpenDropdown)="onFocusInput('startTime')"
                                        (appClickOutside)="handleBlur('startTime')">
                                    </app-dropdown>
                                </div>
                            </div>

                            <!-- To -->
                            <div class="text-center">
                                <p class="m-0 font-12">
                                    <i class="fal fa-minus"></i>
                                </p>
                            </div>

                            <div>
                                <div
                                    class="form-group appointment-form-group appointment-time pr-4px border-bottom-white">
                                    <app-dropdown id="end-time" listId="end-time-list" idKey="i" field="label"
                                        theme="light" itemWidth="150px" scrollHeight="152px"
                                         inactiveItemsKey="isActiveEndTime"
                                        styleClassDropdownList="time-box-shadow" [hasBorderBottomOnActive]="false"
                                        [autoFocus]="focus?.endTime" [focusOnSelectedValue]="true" [fontSize]="14"
                                        [setPositionDynamically]="false" [hasCustomItemTemplate]="true"
                                        [isInline]="true" [options]="endTimeDropdown" [value]="selectedTime.end"
                                        [isDropdownIconVisible]="false" [selectInactiveItems]="false"
                                        (appSelect)="onSelectEndTime($event)"
                                        (appOpenDropdown)="onFocusInput('endTime')"
                                        (appClickOutside)="handleBlur('endTime')">
                                        <ng-template let-item appTemplate="item">
                                            <span class="font-12"
                                                [ngClass]="{ 'disabled-endTime': !item?.isActiveEndTime }">
                                                {{ item?.diffTime ? item?.diffTime : item?.label }}
                                            </span>
                                        </ng-template>
                                    </app-dropdown>
                                </div>
                            </div>

                            <!-- End Date -->
                            <div>
                                <div
                                    class="form-group appointment-form-group appointment-calendar to-calender border-bottom-white calendar-dropdown">
                                    <p-calendar id="end-date" dateFormat="M dd, yy" [minDate]="appointment.date.start"
                                        [(ngModel)]="appointment.date.end" (onSelect)="onEndDateSelect()"
                                         (onFocus)="onFocusInput('calendar')"
                                        (onBlur)="onBlurInput('calendar')" #endDateCalendar>
                                    </p-calendar>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="ui-g-12 p-zero">
                    <div class="ui-g-10 p-zero min-hight50 width-100p">
                        <div class="form-group font-14 mb-20 notes width-100p">
                            <textarea class="pt-2 mt-1 ng-pristine ng-invalid ng-touched" id="appt-notes" name="notes"
                            [(ngModel)]="appointment.description"
                                 placeholder="Notes" required="" rows="4"
                                (change)="handleNote($event)"></textarea>
                        </div>
                    </div>
                </div>
            </div>
            <div class="bd-alert">
                <div class="alert-icon">
                    <i class="fas fa-info-circle"></i>
                </div>
                <p class="m-0">
                    You can over-ride your weekly schedule to block you availability. This would reflect on the slots
                    available at the appointment request form
                </p>
            </div>
        </div>
    </div>
</div>